export default function clone(el) {
  return el.cloneNode(true);
}
